// React
import React, { useState, useRef, useEffect } from "react";

// React Async
import Async from "react-async";

// Components
import { Typeahead } from "react-bootstrap-typeahead";

// Internal Libs
import * as EventifyAPI from "../libs/EventifyAPI";

// Style
import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-bootstrap-typeahead/css/Typeahead-bs4.css";

// UUID
const uuidv4 = require("uuid/v4");

const ListTagsTypeahead = React.forwardRef((props, ref) => {
  const [isLoading, setIsLoading] = useState(false);
  const [reloadProtocol, setReloadProtocol] = useState(null);
  const [originalListArray, setOriginalListArray] = useState([]);
  const [tagsList, setTagsList] = useState([]);
  const [hasLoadedTags, setHasLoadedTags] = useState(false);
  const [allTagsAvailable, setAllTagsAvailable] = useState([]);
  const [tagMap, setTagMap] = useState({});
  const multiple = true;

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    if (props.isSearchMode === true) {
      loadForListId(null);
    } else {
      loadForListId(props.currentListCallback().listid);
    }
  }

  async function loadForListId(listid) {
    loadAllTags(listid).then(allTags => {
      setAllTagsAvailable(allTags);
      var interim = {};
      for (var k = 0; k < allTags.length; k++) {
        const tag = allTags[k];
        interim[tag.raw] = tag;
      }
      setTagMap(interim);
      if (props.isSearchMode === false) {
        getTagsForList(listid).then(getTagsForList => {
          const strippedTags = getTagsForList.map((item, n) => {
            return item.raw;
          });
          setTagsList(strippedTags);
          setHasLoadedTags(true);
          setReloadProtocol(uuidv4());
        });
      } else {
        setHasLoadedTags(true);
        setReloadProtocol(uuidv4());
      }
    });
  }

  // Allow hierarchy to call functions on this component
  // the ref might not actually be necessary
  const dropdownRef = React.useRef();

  React.useImperativeHandle(ref, () => ({
    getSelectedLists: () => {
      return dropdownRef.current.selected;
    },
    listSelectionChanged: listid => {
      setHasLoadedTags(false);
      loadForListId(listid);
    }
  }));

  async function loadAllTags(listid) {
    const result = EventifyAPI.getAllTagsForLists();
    return result;
  }

  async function getTagsForList(listid) {
    const result = EventifyAPI.getTagsForList(listid);
    return result;
  }

  function tagsSelectionChange(selected) {
    var richSelection = [];
    var rawSelection = selected.map((item, n) => {
      var rawValue = null;
      if (typeof item.raw !== "undefined") {
        rawValue = item.raw;
      } else {
        rawValue = item;
      }
      return rawValue;
    });
    var unTagged = [];
    for (var k = 0; k < rawSelection.length; k++) {
      const raw = rawSelection[k];
      var tag = tagMap[raw];
      if (tag !== null && typeof tag !== "undefined") {
        richSelection.push(tag);
      } else {
        tag = {
          tagid: uuidv4(),
          raw: raw,
          stringLowerCase: raw.toLowerCase()
        };
        richSelection.push(tag);
      }
    }

    if (props.isSearchMode === true) {
      props.tagTermFilterUpdated(richSelection);
    } else {
      EventifyAPI.setTagsForList(
        richSelection,
        props.currentListCallback().listid
      ).then(result => {});
      // props.onUpdate(richSelection);
    }
  }

  const list = tagsList;

  function convertListAPIResultToDropdown(data) {
    return (
      <>
        {" "}
        {hasLoadedTags === true ? (
          <Typeahead
            className="tags-typeahead"
            ref={dropdownRef}
            id={`_tagstypeahead`}
            reloadProtocol={reloadProtocol}
            labelKey="raw"
            multiple={multiple}
            allowNew={!props.isSearchMode}
            options={allTagsAvailable}
            defaultSelected={tagsList}
            placeholder={`${props.isSearchMode ? "Filter by Tag" : "Add Tags"}`}
            onChange={tagsSelectionChange}
          />
        ) : (
          <></>
        )}{" "}
      </>
    );
  }

  return <>{convertListAPIResultToDropdown(tagsList)}</>;
});

export default ListTagsTypeahead;
